import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import classNames from 'classnames';
import Path from './Path';
import FormField from '../../components/FormField';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import Logger from '../../logger/logger';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;
const log = Logger.get('BaseAsset');

/**
 * Base class for asset allows to update asset properties.
 */
class BaseAsset extends Component {
	editFolder = {};

	/**
	 * Update internal state of asset then notify component to update state.
	 *
	 * @param {Object} editFolder
	 */
	updateFolderState(editFolder) {
		this.editFolder = editFolder;

		this.setState({
			editFolder: this.editFolder
		});
	}

	/**
	 * Render save folder button.
	 *
	 * @param {Object} document
	 *
	 * @returns {Object}
	 */
	renderSaveButton(document) {
		if (!this.editFolder[document.fileId]) {
			return;
		}

		return (<Button
			variant="outlined"
			data-tid="button-base-asset-save"
			color="primary"
			onClick={() => this.saveFolder(document)}>
			{localize('save')}
		</Button>);
	}

	/**
	 * Render rename folder button.
	 *
	 * @param {Object} document
	 * @returns {Object}
	 */
	renderRenameButton(document) {
		if (this.editFolder[document.fileId]) {
			return;
		}

		return (<Button
			variant="outlined"
			data-tid="button-base-asset-rename"
			color="primary"
			onClick={() => this.updateFolderState({
				...this.editFolder,
				[document.fileId]: {
					name: document.displayName
				}
			})}>
			{localize('rename')}
		</Button>);
	}

	/**
	 * Render folder info.
	 *
	 * @param {Object} document
	 * @returns {Object}
	 */
	renderFolderInfo(document) {
		const { classes } = this.props;

		if (this.editFolder[document.fileId]) {
			return;
		}

		return (<Grid item>
			<Grid container className={classes.fullHeight} alignContent="center">
				<Grid item>
					<Grid container direction="column">
						<Grid item>
							<Grid container>
								<Typography
									className={classNames(classes.label, classes.bold)}>
									{localize('base-asset-display-name')}
								</Typography>
								<Typography
									className={classNames(classes.label)}>
									{document.displayName}
								</Typography>
							</Grid>
						</Grid>
						<Path document={document}/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>);
	}

	/**
	 * Render edit folder text field.
	 *
	 * @param {Object} document
	 * @param {number} index
	 *
	 * @returns {Object}
	 */
	renderEditFolderField(document, index = 0) {
		const { classes } = this.props;

		if (!this.editFolder[document.fileId]) {
			return;
		}

		return (<FormField
			data-tid={`input-base-asset-rename-${index}`}
			value={this.editFolder[document.fileId].name}
			onChange={({ target: { value } }) => this.updateFolderState({
				...this.editFolder,
				[document.fileId]: {
					name: value
				}
			})}
			className={classes.field}
			id={name}
			margin="normal"
		/>);
	}

	/**
	 * Save folder
	 * @param document
	 * @returns {Promise<void>}
	 */
	async saveFolder(document) {
		const { company: { id }, type, updateFolder } = this.props;
		const newName = this.editFolder[document.fileId].name;


		if (newName && newName !== document.displayName) {
			try {
				await updateFolder({
					...document,
					name: this.editFolder[document.fileId].name,
					type,
				}, id);
			} catch (error) {
				const nError = new AppError({
					message: 'BaseAsset.saveFolder() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: error,
					visualisers: { feature: 'BASE_ASSET' }
				});
				log.send(nError);
				throw nError;
			}
		}

		this.updateFolderState({
			...this.editFolder,
			[document.fileId]: false
		});
	}
}

BaseAsset.propTypes = {
	classes: PropTypes.object,
	updateFolder: PropTypes.func,
};

export default BaseAsset;



// WEBPACK FOOTER //
// ./src/components/TeamFolders/BaseAsset.js